import { render, staticRenderFns } from "./apiinfo.md?vue&type=template&id=20fd2b42&"
import script from "./apiinfo.md?vue&type=script&lang=js&"
export * from "./apiinfo.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20fd2b42')) {
      api.createRecord('20fd2b42', component.options)
    } else {
      api.reload('20fd2b42', component.options)
    }
    module.hot.accept("./apiinfo.md?vue&type=template&id=20fd2b42&", function () {
      api.rerender('20fd2b42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/doc/apiinfo.md"
export default component.exports